import { render } from "./_Layout.vue?vue&type=template&id=861a7db4"
import script from "./_Layout.vue?vue&type=script&lang=js"
export * from "./_Layout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__